import React, { useEffect, useMemo } from 'react';
import { Provider } from 'react-redux';
import 'simplebar/dist/simplebar.min.css';
import Router from './pages/Router';
import store from './store';
import './App.less';
import './i18n';
import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import zhHK from 'antd/lib/locale/zh_HK';
import setupSentry from './utils/Sentry';
import { initGTM } from './utils/Gtm';

setupSentry();
if (process.env.NODE_ENV === 'production') {
  initGTM();
}

function App() {
  const {
    i18n: { language },
  } = useTranslation();

  // useEffect(() => {
  //   getUserLanguage().then((res) => {
  //     const { data, errorCode } = res;
  //     if (errorCode === '0' && data.length === 2) {
  //       const value = data[1];
  //       if (value.length === 2) {
  //         const lang = JSON.parse(value[1]).code;
  //         const { changeLanguage } = i18n;
  //         changeLanguage(lang);
  //       }
  //     }
  //   });
  // }, []);

  const locale = useMemo(() => {
    switch (language) {
      case 'en':
        return enUS;
      case 'zh_CN':
        return zhCN;
      case 'zh_HK':
        return zhHK;
      default:
        return enUS;
    }
  }, [language]);

  return (
    <Provider store={store}>
      <div className="App">
        <ConfigProvider locale={locale}>
          <Router />
        </ConfigProvider>
      </div>
    </Provider>
  );
}

export default App;
